export default __webpack_public_path__ + "static/media/cz4.4c2bd12b.svg";